import { __decorate } from "tslib";
import { body } from "@pnp/odata";
import { _GraphQueryableCollection, _GraphQueryableInstance, graphInvokableFactory } from "../graphqueryable.js";
import { graphPost } from "../operations.js";
import { defaultPath, getById } from "../decorators.js";
import { type } from "../utils/type.js";
/**
 * Attachment
 */
export class _Attachment extends _GraphQueryableInstance {
}
export const Attachment = graphInvokableFactory(_Attachment);
/**
 * Attachments
 */
let _Attachments = class _Attachments extends _GraphQueryableCollection {
    /**
     * Add attachment to this collection
     *
     * @param name Name given to the attachment file
     * @param bytes File content
     */
    addFile(name, bytes) {
        return graphPost(this, body(type("#microsoft.graph.fileAttachment", {
            contentBytes: bytes,
            name,
        })));
    }
};
_Attachments = __decorate([
    defaultPath("attachments"),
    getById(Attachment)
], _Attachments);
export { _Attachments };
export const Attachments = graphInvokableFactory(_Attachments);
//# sourceMappingURL=types.js.map